import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MedicineStickersListComponent} from "../../components/medicine-stickers-list/medicine-stickers-list.component";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {ApolloQueryObservable} from "apollo-angular";
import {PrintedSheet} from "../../../shared/view-model/store-management/printed-sheet.type";
import {StickerFormat} from "../../../shared/view-model/store-management/sticker-format.type";
import {
  MedicineStickersService,
  PrintedSheetsResult,
  StickerFormatsResult
} from "../../services/medicine-stickers.service";
import {PrintedSheetCategory} from "../../model/printed-sheets.enum";
import {FileService} from "../../../core/visbos-core/http/file.service";

@Component({
  selector: 'vb-medicine-stickers-view',
  templateUrl: './medicines-stickers-view.component.html',
  styleUrls: ['./medicines-stickers-view.component.css']
})
export class MedicineStickersViewComponent extends AbstractVisbosComponent implements OnInit {

  private printedSheetsList$: ApolloQueryObservable<PrintedSheetsResult>;
  printedSheetsList: PrintedSheet[] = [];

  private stickerFormatList$: ApolloQueryObservable<StickerFormatsResult>;
  stickerFormatList: StickerFormat[] = [];

  searchTerm: FormControl = new FormControl();

  control: FormGroup;

  PrintedSheetCategory;

  @ViewChild('medicineList')
  medicineList: MedicineStickersListComponent;

  constructor(sessionActions: SessionActions, private medService: MedicineStickersService,
              private fb: FormBuilder, private fileService: FileService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

    this.PrintedSheetCategory = PrintedSheetCategory;

    this.actions = [
      {
        label: 'Druckbogen erzeugen',
        icon: 'fa-file-pdf',
        action: () => this.onCreatePdfClicked.apply(this),
        disabled: () => this.isDisabled.apply(this)
      }
    ];

    this.control = this.fb.group({
      printed_sheet_id: [null, Validators.required],
      sticker_format_id: [null, Validators.required],
      training_mode: [false],
    });

  }

  isDisabled(): boolean {
    return !this.control || this.control.invalid;
  }

  ngOnInit() {
    super.ngOnInit();

    this.printedSheetsList$ = this.medService.getPrintedSheets(null, PrintedSheetCategory.Spritzenetiketten);
    this.addComponentData(this.printedSheetsList$);

    this.dataSubscriptions.push(this.printedSheetsList$.subscribe(res => {
      this.printedSheetsList = res.data.printedSheets;
    }));

    this.stickerFormatList$ = this.medService.getStickerFormats();
    this.addComponentData(this.stickerFormatList$);

    this.dataSubscriptions.push(this.stickerFormatList$.subscribe(res => {
      this.stickerFormatList = res.data.stickerFormats;
    }));
  }

  onPrintedSheetSelected(printedSheet: PrintedSheet) {
    this.control.patchValue({
      printed_sheet_id: printedSheet.cuid
    });
    //this.cd.detectChanges();
  }

  onCreatePdfClicked() {
    let data = this.medicineList.printList;

    let cuids = [];
    let printedSheetCuid = this.control.get('printed_sheet_id').value;
    let stickerFormatCuid = this.control.get('sticker_format_id').value;
    let trainingMode = this.control.get('training_mode').value;

    for (let key in data) {
      for (let i = 1; i <= data[key]; i++) {
        cuids.push(key);
      }
    }

    if (!cuids || cuids.length == 0) {
      this.sessionActions.pushMessage("Bitte geben Sie für mindestens ein Medikament eine Anzahl an Druckseiten an!", MessageType.ERROR, 'Fehlende Angaben');
      return;
    }

    this.sessionActions.pushMessage('Druckbögen werden erzeugt, Sie werden benachrichtigt, sobald die PDF-Datei verfügbar ist. Dies kann einige Sekunden dauern.', MessageType.INFO, 'Spritzenetiketten');

    this.dataSubscriptions.push(
      this.medService.createMedicineStickersPdf(cuids, null, printedSheetCuid, stickerFormatCuid, trainingMode).subscribe(
        res => {
          this.sessionActions.pushMessage('Der Druckbogen wurde erfolgreich generiert!', MessageType.SUCCESS, 'Spritzenetiketten');
          let base64Data = res.data.generateMedicineStickersPDF;
          let blob = this.fileService.base64toBlob(base64Data, 'application/pdf', 512);
          this.fileService.saveAs(blob, 'druckbogen-spritzenetiketten.pdf');
        },
        err => {
          this.sessionActions.throwError(err, 'Fehler bei der Erstellung der Druckbögen, bitte wenden Sie sich an den Support!');
        }));

  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/view-components/medicines-stickers-view/medicines-stickers-view.component.ts